/**
 * Append the next collection page when the grid sentinel enters view.
 */
if (!customElements.get('smarte-collection-infinite')) {
  class SmarteCollectionInfinite extends HTMLElement {
    connectedCallback() {
      this.sentinel = this.querySelector('[data-infinite-sentinel]');
      this.spinner = this.querySelector('.loading__spinner');
      this.nextUrl = this.dataset.nextUrl || '';
      this.loading = false;

      if (!this.nextUrl || !this.sentinel) {
        this.hidden = true;
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
        },
        { rootMargin: '800px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }

    async loadMore() {
      if (this.loading || !this.nextUrl || !this.isConnected) return;

      const grid = document.getElementById('product-grid');
      if (!grid) return;

      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.spinner?.classList.remove('hidden');
      this.controller = new AbortController();

      try {
        const url = new URL(this.nextUrl, window.location.origin);
        if (grid.dataset.id) url.searchParams.set('section_id', grid.dataset.id);

        const response = await fetch(url.toString(), { signal: this.controller.signal });
        if (!response.ok) throw new Error(`Failed to load more products (${response.status})`);

        const html = await response.text();
        if (!this.isConnected) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingGrid = doc.getElementById('product-grid');
        if (incomingGrid) {
          const fragment = document.createDocumentFragment();
          Array.from(incomingGrid.children).forEach((child) => {
            fragment.appendChild(document.importNode(child, true));
          });
          grid.appendChild(fragment);
        }

        const nextHost = doc.querySelector('smarte-collection-infinite');
        this.nextUrl = nextHost?.dataset.nextUrl || '';

        if (this.nextUrl) {
          this.dataset.nextUrl = this.nextUrl;
        } else {
          delete this.dataset.nextUrl;
          this.observer?.disconnect();
          this.hidden = true;
        }
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
        this.spinner?.classList.add('hidden');
      }
    }
  }

  customElements.define('smarte-collection-infinite', SmarteCollectionInfinite);
}
